import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { AUTH_TOKEN } from "constants/AuthConstant";
import CollateralAssetCodeService from "services/Setup/Master/collateralAssetCodeService";
import { message, notification } from "antd";

export const initialState = {
  loading: false,
  message: "",
  showMessage: false,
  redirect: "",
  token: localStorage.getItem(AUTH_TOKEN) || null,
  result: {},
  collateralAssetCodeList: {},
};

export const getCollateralAssetCodeList = createAsyncThunk(
  "collateralAssetCode/getCollateralAssetCodeList",
  async (userInput, { rejectWithValue }) => {
    try {
      const response =
        await CollateralAssetCodeService.getCollateralAssetCodeList(userInput);
      if (response.status === 200) {
        if (response && response.data) {
          return response.data;
        }
      } else {
        console.log("Selain Response 200");
       
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const collateralAssetCode = createSlice({
  name: "collateralAssetCode",
  initialState,
  reducers: {
    showNotification: (state, action) => {
      state.message = action.payload;
      state.showMessage = true;
      state.loading = false;
    },
    hideNotification: (state) => {
      state.message = "";
      state.showMessage = false;
    },
    showLoading: (state) => {
      state.loading = true;
    },
  },

  extraReducers: (builder) => {
    builder
      //get collateralAsset code list
      .addCase(getCollateralAssetCodeList.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getCollateralAssetCodeList.fulfilled, (state, action) => {
        state.loading = false;
        state.collateralAssetCodeList = action.payload;
      })
      .addCase(getCollateralAssetCodeList.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      });
  },
});

export const { showNotification, hideNotification, showLoading } =
  collateralAssetCode.actions;

export default collateralAssetCode.reducer;
